import { Playground } from "docz";
import { SvgIcon } from "../../../../../src/gatsby-theme-docz/tools/SvgIcon";
import githubSvg from "../../../../../src/__docz__/images/github.svg";
import demoGif from "../../../../../src/__docz__/images/demo.gif";
import * as React from 'react';
export default {
  Playground,
  SvgIcon,
  githubSvg,
  demoGif,
  React
};